import { render, staticRenderFns } from "./JeecgOrderDMainModal.vue?vue&type=template&id=125670cb&scoped=true&"
import script from "./JeecgOrderDMainModal.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderDMainModal.vue?vue&type=script&lang=js&"
import style0 from "./JeecgOrderDMainModal.vue?vue&type=style&index=0&id=125670cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125670cb",
  null
  
)

export default component.exports